<div class="pag-container">
  <!-- <h1>{{labelTest}}</h1> -->
  <app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink=""></app-campaign-3-breadcrumb>

  <div class="header-row">
    <h1 class="bold-text header-blue">{{ 'baskets.import_from_csv_title' | translate }}</h1>
    <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" (click)="onGoBack()"
      [label]="'common.back' | translate">
    </button>
  </div>

  <div class="ui-g-12 prova" *ngIf="showTable">


    <!-- nuove colonne da guardare in issue -->
    <app-campaign-3-kontable #basketImportArticlesKontable [columns]="[
        { field: 'id', title: 'baskets.id', filterType: textFilter, bodyTemplate: idTemplate},
        { field: 'row_index', title: 'baskets.row_index', filterType: textFilter, bodyTemplate: rowTemplate },
        { field: 'product_item_host_code', title: 'baskets.product_item_host_code', filterType: textFilter },
        { field: 'description', title: 'baskets.description', filterType: textFilter },
        { field: 'product_item_id', title: 'baskets.product_item_id', filterType: textFilter },
        { field: 'error_log', title: 'baskets.error_log', filterType: noFilter }
      ]" [paginationType]="paginationType" [showInfoButton]="false" [showDetailsButton]="false"
      [showRecoverButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showEditButton]="false"
      [allowSelectRow]="false" [showRowButtons]="false" [filterBySingleColumn]="true"
      [service]="basketImportDetailService">

      <ng-template #idTemplate let-row>
        <span class="center-number">
          {{ row.id }}
        </span>
      </ng-template>

      <ng-template #rowTemplate let-row>
        <span class="center-number">
          {{ row.row_index }}
        </span>
      </ng-template>


    </app-campaign-3-kontable>

  </div>


</div>


// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-import-articles/basket-import-articles.component.html